import React from 'react';

const DeleteConfirmModal = ({ projectAddress, onConfirm, onCancel, onArchive }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <h2 className="text-2xl font-bold mb-4 text-red-600">Delete Deal Permanently?</h2>
        <p className="mb-4 text-gray-700">
          Are you sure you want to permanently delete <strong>{projectAddress || 'this deal'}</strong>? This will remove the deal and all its tasks. This action cannot be undone.
        </p>
        <p className="mb-6 text-sm" style={{ color: '#516469' }}>
          💡 If you just want to get it off your dashboard, archiving is a better option — you can always restore it later.
        </p>
        <div className="flex flex-col gap-3">
          {onArchive && (
            <button onClick={onArchive}
              className="w-full px-4 py-3 rounded font-semibold"
              style={{ backgroundColor: '#F0F4F5', color: '#071D39', border: '2px solid #d0d4da' }}>
              Archive Instead
            </button>
          )}
          <div className="flex gap-3">
            <button onClick={onCancel}
              className="flex-1 px-4 py-3 rounded font-semibold"
              style={{ backgroundColor: '#F3F4F6', color: '#374151', border: '2px solid #D1D5DB' }}>
              Cancel
            </button>
            <button onClick={onConfirm}
              className="flex-1 px-4 py-3 rounded font-semibold"
              style={{ backgroundColor: '#EF4444', color: '#FFFFFF', border: '2px solid #DC2626' }}>
              Delete Permanently
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
